module.exports = __webpack_public_path__ + "static/media/1-1.495e2ec0.png";